export interface NutrafolAcademyVideo {
  src: string;
  poster: string;
}

export interface NutrafolAcademyQuizOption {
  image: string;
  productName: string;
  video: NutrafolAcademyVideo;
}

export interface NutrafolAcademyCourse {
  title: string;
  description: string;
  author: string;
  authorTitle: string;
  image: string;
  duration: string;
  tag?: string;
  video?: NutrafolAcademyVideo;
  quiz?: {
    question: string;
    options: NutrafolAcademyQuizOption[];
  };
}

export interface NutrafolAcademyData {
  seo: {
    title: string;
    description: string;
  };
  hero: {
    title: string;
    description: string;
    desktopImage: string;
    tabletImage: string;
    mobileImage: string;
  };
  learning: {
    title: string;
    description: string;
    courses: NutrafolAcademyCourse[];
    additionalCourses?: NutrafolAcademyCourse[];
  };
  faqAccordion: {
    heading: string;
    accordions: Array<{ title: string; content: string }>;
  };
}

export type ModalView = "quiz" | "video" | "email" | "done";

export const MODAL_VIEWS = {
  QUIZ: "quiz",
  VIDEO: "video",
  EMAIL: "email",
  DONE: "done",
} as const;
